exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detail_2553dbf{line-height:200%}.detail_2553dbf .detail_content_832e663{margin-top:10px;margin-bottom:15px;border:1px solid #f0f2f8;border:solid 1px var(--color-border);border-radius:4px;padding:10px;min-height:180px}.table_cell_feec2d6{padding:5px 0;line-height:150%}", ""]);

// exports
exports.locals = {
	"detail": "detail_2553dbf",
	"detail_content": "detail_content_832e663",
	"table_cell": "table_cell_feec2d6"
};